// eslint-disable-next-line import/prefer-default-export
export const LOAD_MACHINES = 'LOAD_MACHINES';
export const ADD_NEW_MACHINE = 'ADD_NEW_MACHINE';
export const EDIT_MACHINE = 'EDIT_MACHINE';
export const SET_EMPTY_EDITABLE_MACHINE = 'SET_EMPTY_EDITABLE_MACHINE';
export const LOAD_EDITABLE_MACHINE = 'LOAD_EDITABLE_MACHINE';
export const DELETE_MACHINE = 'DELETE_MACHINE';
